var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm._isMobile() ? '' : 'minwidthApp',attrs:{"id":"app"}},[(!(_vm._isMobile() || _vm.$route.name === 'AppIndex' || !_vm.isLogged))?_c('event-header-nav'):_vm._e(),_c('div',{staticClass:"content"},[_c('router-view')],1),_c('compare-utils')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6eb3320d","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/index/App.vue
// module id = null
// module chunks = 